import { useMutation, useQueryClient } from '@tanstack/react-query'
import { adminApi } from '../adminApi.js'
import { tenantAuditKey } from './useTenants.js'
import type { SetupLinkResponse } from '../types.js'

/**
 * Slice 6 — admin generates an owner password-reset link. Same response
 * shape as the setup-link regen so the MessageTemplatesModal renders
 * identically; the audit row is owner_password_reset_link_sent.
 */
export function useSendOwnerPasswordReset(tenantId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () =>
      adminApi.post<SetupLinkResponse>(
        `/tenants/${tenantId}/password-reset`,
      ),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: tenantAuditKey(tenantId) })
    },
  })
}
